export default __webpack_public_path__ + "static/media/SB.436b9400.svg";